module.exports = __webpack_public_path__ + "images/accents/accent-video-heart-rs@2x-d9024230588dabdb378c9ccae273a174.webp";